import { getThemeId } from '../../data/models/funnelOrder/theme'
import { getSiteCurrencyISO, SiteCurrency } from '../../data/models/locale'
import { AppState } from '../../data/state'
import { store } from '../../store/store'
import { getMetrics } from '../metrics'
import { EventTypes } from '../middleware/ActionTypes'
import { IEntryPointDetails } from './models/IEntryPointData'

export function trackEntryPoint(name: string) {
  try {
    const metrics = getMetrics()
    metrics.api.track(EventTypes.ENTRY_POINT, getEntryPointDetails(name))
  } catch (e) {
    console.error(`Metrics failed because: ${e}`)
  }
}

function getEntryPointDetails(name: string): IEntryPointDetails {
  const state: AppState = Object.assign({}, store.getState())

  return {
    currency: getSiteCurrencyISO(state.locale.currency || SiteCurrency.euro),
    trip_id: getThemeId(state.funnelOrder.theme),
    name,
    category: 'trips',
  }
}

export function FacebookEntryPoint(data: IEntryPointDetails): any {
  return {
    value: 1,
    currency: data.currency,
    content_id: data.trip_id,
    content_name: data.name,
    content_category: data.category,
  }
}

export function SnapchatEntryPoint(data: IEntryPointDetails): any {
  return {
    price: 1,
    currency: data.currency,
    item_ids: [data.trip_id],
    item_category: data.category,
  }
}
